import {
  getHighestUserRole,
  USER_ROLE_ATTRIBUTES,
  UserRole,
} from 'lib-shared-user-role';
import { ReactNode } from 'react';

import { UserModalRoleOption } from 'components/usersModal/userModal.types';

export const legacyRolesTooltipContent = (
  <>
    <strong>Agent</strong>
    <p>
      An agent is the default staff role in Dixa. Agents can be assigned to one
      or more queues and have global access to Search, Contacts, Team Presence,
      and Transfer Capabilities. They do not have access to Analytics or System
      Settings. They can only see their queues in the Dashboard.
    </p>
    <strong>Team Lead</strong>
    <p>
      A team lead is a people manager and can adjust agent assignments based on
      data. A team lead retains all the rights of an agent, but also has access
      to Analytics and can manage the agents and teams assigned to queues.
    </p>
    <strong>System Administrator</strong>
    <p>
      A system admin is a platform manager and can help keep things running
      smoothly in Dixa. They retain all the rights of a team lead, but can also
      add or demote agents, edit agent workload settings, edit queues, manage
      templates, manage tags, and edit flows.
    </p>
    <strong>Administrator</strong>
    <p>
      An administrator is a global admin or owner in Dixa. They have complete
      access to the platform including all the rights of a system admin.
      Additionally, they can manage organization and billing info, create and
      deactivate queues, create new channels and flows, and manage integration
      settings.
    </p>
  </>
);

export function getLegacyRolesOptions(
  roles: UserRole[],
): UserModalRoleOption[] {
  const roleOptions: UserModalRoleOption[] = [
    {
      id: 'agent',
      name: USER_ROLE_ATTRIBUTES['agent'].prettyName,
    },
    {
      id: 'teamlead',
      name: USER_ROLE_ATTRIBUTES['teamlead'].prettyName,
    },
    {
      id: 'systemadmin',
      name: USER_ROLE_ATTRIBUTES['systemadmin'].prettyName,
    },
    {
      id: 'admin',
      name: USER_ROLE_ATTRIBUTES['admin'].prettyName,
    },
  ];

  const currentAgentHighestRole = getHighestUserRole(roles);

  const { privilegeLevel: currentAgentPrivilegeLevel } =
    USER_ROLE_ATTRIBUTES[currentAgentHighestRole];

  return currentAgentHighestRole === 'admin'
    ? roleOptions
    : roleOptions.filter(
        ({ id: role }) =>
          USER_ROLE_ATTRIBUTES[role].privilegeLevel >
          currentAgentPrivilegeLevel,
      );
}

export function getLegacyRolesTooltipContent(
  isCurrentUser: boolean,
): ReactNode {
  if (isCurrentUser) {
    return 'You can not change your own profile role.';
  }

  return legacyRolesTooltipContent;
}
